function SelectSensorClassificationComponent({
  sensorTypeList,
  selectEquipmentAPICall,
  setSelectSensorClassification,
  setCheckedItems,
  setSensorUnit,
  setApiEquipmentList,
  setAlertTypeEnabled
}) {
  const onSensorTypeSelect = ({ slug, id ,is_alert_type_enabled }) => {
    setSensorUnit(slug);
    setCheckedItems([]);
    setApiEquipmentList([]);
    setSelectSensorClassification(true);
    selectEquipmentAPICall(id);
    setAlertTypeEnabled(is_alert_type_enabled);
  };

  return (
    <div className="select-sensor-classification">
      <h3>Select sensor type</h3>
      <p className="mt-2 mb-5 txt-15">
        Select the type of sensor you <br></br> want to set alert for.
      </p>

      <div>
        {sensorTypeList &&
          sensorTypeList.map((eachType) => {
            return (
              <button
                key={eachType.id}
                onClick={() => onSensorTypeSelect({ slug: eachType.slug, id: eachType.id, is_alert_type_enabled:eachType.is_alert_type_enabled })}
                className="btn-grad btn w-100 mb-3">
                {eachType.name}
              </button>
            );
          })}
      </div>
    </div>
  );
}

export default SelectSensorClassificationComponent;
